import { atom, selector } from 'recoil'

export const exploreExpensesQueryState = atom<Recoil.ExploreExpensesQuery>({
	key: 'exploreExpensesQueryState',
	default: {
		match: {},
		sort: '-timestamps.createdAt',
		paginate: {
			page: 1,
			pageSize: 10,
		},
		textSearch: undefined,
	},
})

export const exploreExpensesPaginateQuery = selector<
	Recoil.ExploreExpensesPaginate
>({
	key: 'exploreExpensesPaginateQuery',
	get: ({ get }) => get(exploreExpensesQueryState).paginate,
})

export const exploreIncomesQueryState = atom<Recoil.ExploreIncomesQuery>({
	key: 'exploreIncomesQueryState',
	default: {
		match: {},
		sort: '-timestamps.createdAt',
		paginate: {
			page: 1,
			pageSize: 10,
		},
		textSearch: undefined,
	},
})

export const exploreIncomesPaginateQuery = selector<
	Recoil.ExploreIncomesPaginate
>({
	key: 'exploreIncomesPaginateQuery',
	get: ({ get }) => get(exploreIncomesQueryState).paginate,
})
